import { ReactNode } from 'react'
import { Spacer, Text } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/common-components/separated-list-ui'

import ResponsiveWrapper from '../../ReponsiveWrapper'

type Props = {
  title: string
  description?: string
  children: Array<ReactNode>
  html?: boolean
}

const FactsSection = ({ title, description, children, html }: Props) => (
  <section>
    <Text as="h3">
      <div className="safety_facts-block-title">{title}</div>
    </Text>
    {!!description && (
      <>
        <ResponsiveWrapper mobile={<Spacer />} desktop={<Spacer size={Spacer.Size.Large} />} />
        <Text as="span" html={html}>
          <div className="safety_body">{description}</div>
        </Text>
      </>
    )}
    <ResponsiveWrapper
      mobile={<Spacer size={Spacer.Size.XLarge} />}
      desktop={<Spacer size={Spacer.Size.X2Large} />}
    />
    <div className="page-section__facts">
      <SeparatedList
        separator={
          <ResponsiveWrapper
            mobile={<Spacer size={Spacer.Size.Large} />}
            desktop={
              <Spacer size={Spacer.Size.X4Large} orientation={Spacer.Orientation.Vertical} />
            }
          />
        }
      >
        {children}
      </SeparatedList>
    </div>
    <ResponsiveWrapper
      mobile={<Spacer size={Spacer.Size.X2Large} />}
      desktop={<Spacer size={Spacer.Size.X4Large} />}
    />
  </section>
)

export default FactsSection
